/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { useFormik } from "formik";
import { Paperclip, SkipBack } from "react-feather";
import * as Yup from "yup";
import { Button, Form, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { StyledSelect } from "../../../components/StyledSelect";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { postMessageTicketing } from "../../../services/messageTicketingService";
import { handleErrors } from "../../../services/handleErrors";
import { fetchPiAsignable } from "../../../services/ticketingServices";
import useFetcher from "../../../hooks/useFetcher";

const NewConversation = ({ ticketId, addConversation, setNewConversationToggle }) => {
  const userData = JSON.parse(localStorage.getItem("authUser"));
  const [piAsignable, isLoadingPiAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [isLoadingEditor, setIsLoadingEditor] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const handleConfirmSelectedFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  const handleUploadFileButton = () => {
    document.getElementById("upfile").click();
  };

  const pisOptions = !isLoadingPiAsignable
    ? piAsignable
        .filter((item) => item.email2 !== null)
        .map((item) => {
          return { label: item.nombreApellido, value: item.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const formik = useFormik({
    initialValues: {
      subject: "",
      to: [],
      body: "",
      type: "comment",
    },
    onSubmit: async (conv) => {
      try {
        const { message, result } = await postMessageTicketing(ticketId, {
          ...conv,
          to: [piAsignable.filter((item) => conv.to.includes(item.itemId)).map((item) => item.email2), userData.user.Pi.email2],
          pis: [conv.to, userData.user.Pi.itemId],
          files: document.getElementById("upfile").files,
        });
        addConversation(result.messages[0]);
        toast.success(message);
      } catch (error) {
        handleErrors(error);
      }
    },
    validationSchema: Yup.object().shape({
      subject: Yup.string().typeError("Debe escribir el asunto del mensaje").required("Este campo es requerido."),
      to: Yup.array().min(1, "Se debe elegir destinatarios").required("Este campo es requerido"),
      body: Yup.string().typeError("Debe escribir el mensaje").required("Este campo es requerido."),
    }),
  });

  return (
    <BlurSpinner isLoading={formik.isSubmitting || isLoadingEditor}>
      <div className="card-body email-compose p-4 custom-scrollbar">
        <div className="email-top compose-border">
          <div className="row">
            <div className="col-sm-12 xl-50 d-flex">
              <Button size="xs" color="link" className="pl-0" onClick={() => setNewConversationToggle(false)}>
                <SkipBack size="22" />
              </Button>
              <h5 className="mx-0">Nueva conversación</h5>
            </div>
          </div>
        </div>
        <div className="email-wrapper">
          <Form onSubmit={formik.handleSubmit}>
            <FormGroup>
              <label htmlFor="to" className="col-form-label pt-0 w-100" />
              <StyledSelect
                defaultValue={formik.values.to}
                isMulti
                name="to"
                placeholder="Añadir personas"
                options={pisOptions}
                onChange={(values) =>
                  formik.setFieldValue(
                    "to",
                    values.map((val) => val.value)
                  )
                }
                onBlur={() => formik.setFieldTouched("to")}
                isClearable={false}
              />
              {formik.errors.to && formik.touched.to && <div className="input-feedback">{formik.errors.to}</div>}
            </FormGroup>

            <FormGroup>
              <label htmlFor="subject">Asunto</label>
              <input className="form-control" id="subject" name="subject" type="text" onChange={formik.handleChange} value={formik.values.subject} />
              {formik.errors.subject && formik.touched.subject && <div className="input-feedback">{formik.errors.subject}</div>}
            </FormGroup>

            <FormGroup>
              <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                <input
                  id="upfile"
                  name="upfile"
                  type="file"
                  onChange={handleConfirmSelectedFiles}
                  multiple
                  accept="image/jpeg,image/gif,image/png,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
              </Form>
              <Label label className="col-form-label pt-0 w-100">
                Adjuntar archivos
              </Label>
              <Button color="link" size="xs" onClick={handleUploadFileButton}>
                <Paperclip size="24" />
              </Button>
              {selectedFiles.length > 0 ? (
                <div className="normalized_ul">
                  <Label className="col-form-label pt-0 w-100">Archivos adjuntos</Label>
                  <ul>
                    {Array.from(selectedFiles).map((file) => (
                      <li key={file.name}>{file.name}</li>
                    ))}
                  </ul>
                </div>
              ) : (
                <></>
              )}
            </FormGroup>

            <FormGroup className="normalized_ul">
              <label htmlFor="body">Mensaje</label>
              <CKEditor
                className="text-dark"
                editor={ClassicEditor}
                config={{
                  removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                }}
                data={formik.values.body}
                onReady={() => setIsLoadingEditor(false)}
                onChange={(event, editor) => formik.setFieldValue("body", editor.getData())}
                onBlur={() => formik.setFieldTouched("body")}
              />

              {formik.errors.body && formik.touched.body && <div className="input-feedback">{formik.errors.body}</div>}
            </FormGroup>

            <FormGroup>
              <Button type="submit" color="primary">
                Enviar
              </Button>
            </FormGroup>
          </Form>
        </div>
      </div>
    </BlurSpinner>
  );
};

export default NewConversation;
